<template>
  <div class="InspectionRes">
    <div class="Result">
      <h1 id="ResultHead" style="background-color: #2196F3;">
        <span style="color: white">Ergebnis der Berechnung: {{assessmen}} Punkte</span>
      </h1>
      <v-data-table
        :headers="ResultHeaders"
        :items="ResultItems"
        item-key="name"
        class="ResultTable"
        hide-default-footer
      >
        <template slot="item" slot-scope="props">
          <tr
            v-bind:class="[(props.item.min <= assessmen && props.item.max >= assessmen) ? lineClass : '']"
          >
            <td class="text-xs-center" style="font-size: 150%">{{props.item.intervall}}</td>
            <td class="text-xs-center" style="font-size: 150%">{{ props.item.points }}</td>
          </tr>
        </template>
      </v-data-table>
      <div class="buttons">
        <!-- <v-btn color="blue" @click="saveInsp" large class="ma-2">
          <span style="color: white; font-size: 110%;">Speichern</span>
        </v-btn> -->
        
        <v-dialog max-width="1000px" v-model="showH" :retain-focus="false">
          <template v-slot:activator="{ on }">
            <v-btn color="blue" slot="activator" large v-on="on" class="ma-2">
              <span style="color: white; font-size: 110%;">Verlauf</span>
            </v-btn>
          </template>
          <v-card>
            <v-toolbar color="#2E9AFE" height="50px">
              <v-toolbar-title style="color: white; font-size: 150%">Verlauf</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn small @click="closeH" icon>
                <v-icon color="white">fas fa-times</v-icon>
              </v-btn>
            </v-toolbar>

            <v-card-text>
              <v-data-table
                :headers="headers"
                :items="items"
                item-key="name"
                hide-default-footer
                class="ResultTable"
              >
                <template slot="item" slot-scope="props">
                  <tr v-if="!(props.item.header.length == 0)">
                    <td class="text-xs-left" style="font-size: 120%">
                      <strong>{{ props.item.header }}</strong>
                    </td>
                    <td class="text-xs-left" style="font-size: 120%">{{ props.item.name }}</td>
                    <td style="font-size: 120%">{{ props.item.assess }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-dialog>
        <v-btn v-if="alreadySaved && !$store.state.loading && !$store.state.fetchloading" color="blue" @click="printPDF" large class="ma-2">
          <span style="color: white; font-size: 110%;">Protokoll ausdrucken</span>
        </v-btn>
        <v-btn color="blue" @click="$router.push('Facilities')" small fab>
          <v-icon color="white">fas fa-arrow-right</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  props: [
    "assessmen",
    "textI1",
    "textI2",
    "textI3",
    "textI4",
    "textI5",
    "textI6",
    "textI7",
    "textI8",
    "headerI1",
    "headerI2",
    "headerI3",
    "headerI4",
    "headerI5",
    "headerI6",
    "headerI7",
    "headerI8",
    "assessI1",
    "assessI2",
    "assessI3",
    "assessI4",
    "assessI5",
    "assessI6",
    "assessI7",
    "assessI8"
  ],
  data() {
    return {
      pagination: {},
      lineClass: "colorLine",
      intervall: "",
      showH: false,
      alreadySaved: false,
      items: [
        { header: this.headerI1, name: this.textI1, assess: this.assessI1 },
        { header: this.headerI2, name: this.textI2, assess: this.assessI2 },
        { header: this.headerI3, name: this.textI3, assess: this.assessI3 },
        { header: this.headerI4, name: this.textI4, assess: this.assessI4 },
        { header: this.headerI5, name: this.textI5, assess: this.assessI5 },
        { header: this.headerI6, name: this.textI6, assess: this.assessI6 },
        { header: this.headerI7, name: this.textI7, assess: this.assessI7 },
        { header: this.headerI8, name: this.textI8, assess: this.assessI8 }
      ],
      headers: [
        {
          text: "Tabelle",
          align: "left",
          value: "header",
          sortable: false
        },
        {
          text: "Kriterium",
          align: "left",
          value: "name",
          sortable: false
        },
        {
          text: "Relative Bewertung",
          align: "center",
          value: "assess",
          sortable: false
        }
      ],
      ResultItems: [
        { intervall: "1 Jahr", points: "0-3", min: 0, max: 3 },
        { intervall: "6 Monate", points: "4-6", min: 4, max: 6 },
        { intervall: "3 Monate", points: "7-8", min: 7, max: 8 },
        { intervall: "2 Monate", points: "9-10", min: 9, max: 10 },
        { intervall: "1 Monat", points: "größer 10", min: 11, max: 20 }
      ],
      ResultHeaders: [
        {
          text: "Intervall für die augenscheinlichen Inspektion",
          align: "center"
        },
        {
          text: "Punktezahl",
          align: "center"
        }
      ]
    };
  },
  mounted: function(){ 
    this.saveInsp();
  },
  methods: {
    printPDF() {
      // this.saveInsp();
      console.log("printi");
      var inspectionList = this.items;
      var resItems = this.ResultItems;

      var o = this.$store.state.inspections.find(
        x => x.inspectionID === this.$store.state.inspectingID
      );

      var clearedList = [];
      inspectionList.forEach(function(element) {
        if (element.header.length != 0) {
          clearedList.push(element);
        }
      });
      let score = this.assessmen;

      clearedList.push({
        header: "Gesamtpunktezahl",
        name: "",
        assess: this.assessmen
      });

      // add arrow to result
      resItems.filter(x=> score >= x.min && score <= x.max).map(x=>x.res="-->");

      var facName = o.facName;
      var ropeName = o.roName;
      var ropeType = o.roType;
      var firstName = this.$store.state.firstName;
      var lastName = this.$store.state.lastName;
      var date = o.date;
      var interval = o.interval;

      var vm = this;
      var columns = [
        { title: "Kriterium", dataKey: "header" },
        { title: "Beschreibung", dataKey: "name" },
        { title: "Bewertung", dataKey: "assess" }
      ];

      var resColumns = [
        { title: "Ergebnis", dataKey: "res" },
        { title: "Gesamtauswertung", dataKey: "points" },
        {
          title: "Maximales Intervall für die Sichtprüfung",
          dataKey: "intervall"
        }
      ];

      var doc = new jsPDF("p", "pt");
      doc.setFontSize(18);
      // doc.setFontType("bold");
      doc.text(
        50,
        55,
        "Protokoll der Berechnung des Intervalls für die Sichtprüfung"
      );
      doc.text(250, 75, "an Seilen");
      doc.setFontSize(12);
      doc.setFontType("normal");
      doc.text(180, 90, "gemäß ÖNORM EN 12927:2019 (Anhang E)");
      doc.line(40, 95, 40, 215);
      doc.line(555, 95, 555, 215);
      doc.line(40, 215, 555, 215);
      doc.line(40, 95, 555, 95);
      doc.text(50, 110, "Name: " + firstName + " " + lastName);
      doc.text(
        50,
        135,
        "Datum: " + new Date(date).toLocaleDateString(["de-AT"])
      );
      doc.text(50, 160, "Anlage: " + facName);
      doc.text(50, 185, "Seilbezeichnung / Norm: " + ropeName);
      doc.text(50, 210, "Seiltyp: " + ropeType);
      doc.setFontType("bold");

      // doc.text(20, 100, "Name");

      doc.autoTable(columns, clearedList, {
        margin: { top: 230 },
        theme: "striped",
        //      headerStyles: { fillColor: [33, 150, 243] },
        columnStyles: {
          header: { cellWidth: 130 },
          name: { cellWidth: 300 },
          assess: { cellWidth: 80, halign: "center" }
        },
        allSectionHooks: true,
        willDrawCell: function(data) {
          if (data.row.raw.header === "Gesamtpunktezahl") {
            // doc.setTextColor(231, 76, 60) // Red
            doc.setFontStyle("bold");
          }
        }
      });
      doc.autoTable(resColumns, resItems, {
        columnStyles: {
          // intervall: { halign: 'right'}
        },
        styles: {
          minCellWidth: 110,
        },
        allSectionHooks: true,
        willDrawCell: function(data) {
          console.log(data);
          if (score >= data.row.raw.min && score <= data.row.raw.max) {
            // doc.setTextColor(36, 171, 24); // Green
            doc.setFontStyle("bold");
          }
        }
      });

      let finalY = doc.autoTable.previous.finalY;

      doc.setFontSize(20);
      // doc.text(80, finalY+30, "Maximales Intervall für die Sichtprüfung: " + interval);
      var pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
      doc.text("Maximales Intervall für die Sichtprüfung: " + interval, pageWidth/2, finalY+30, 'center')

      let text = 'Diese Berechnung wurde auf Grundlage der genannten Norm durchgeführt. Es wird darauf hingewiesen, dass die Vorgaben des Seilherstellers bzw. der Seilbahnbehörde zu beachten sind. Diese Berechnung kann als Vorlage für den Seilhersteller zur allfälligen Änderung von Betriebs- und Wartungsanleitungen bzw. für die Behörde zu allfälligen Anpassungen der Betriebsvorschriften dienen.';
      doc.setFontSize(10);
      doc.setFontType("normal");
      doc.text(text, 40, finalY + 50, {maxWidth: 510, align: "justify"});

      finalY = finalY + 80;
      doc.setFontSize(12);
      doc.setFontType("normal");
      doc.text(
        40,
        finalY + 50,
        "Datum:_________________                           Unterschrift:_________________"
      );

      doc.setFontSize(10);
      doc.setFontType("normal");
      doc.text(
        120,
        finalY + 90,
        "Die App für diese Berechnung wurde zur Verfügung gestellt von der"
      );
      doc.setFontType("bold");
      doc.text(
        133,
        finalY + 102,
        "Versuchsanstalt für Maschinenbau an der HTL-Anichstraße"
      );
      doc.setFontType("normal");
      doc.text(220, finalY + 114, "https://www.vamibk.at/");
      doc.save("Prüfungsintervallberechnung.pdf");
      doc.output("Prüfungsintervallberechnung.pdf");
    },
    closeH() {
      this.showH = false;
    },
    created() {
      if (this.assessmen <= 3) {
        this.intervall = "1 Jahr";
      }
      if (this.assessmen <= 6 && this.assessmen >= 4) {
        this.intervall = "6 Monate";
      }
      if (this.assessmen <= 8 && this.assessmen >= 7) {
        this.intervall = "3 Monate";
      }
      if (this.assessmen <= 10 && this.assessmen >= 9) {
        this.intervall = "2 Monate";
      }
      if (this.assessmen > 10) {
        this.intervall = "1 Monat";
      }
    },
    saveInsp() {
      if (!this.alreadySaved) {
        if (this.assessmen <= 3) {
          this.intervall = "1 Jahr";
        }
        if (this.assessmen <= 6 && this.assessmen >= 4) {
          this.intervall = "6 Monate";
        }
        if (this.assessmen <= 8 && this.assessmen >= 7) {
          this.intervall = "3 Monate";
        }
        if (this.assessmen <= 10 && this.assessmen >= 9) {
          this.intervall = "2 Monate";
        }
        if (this.assessmen > 10) {
          this.intervall = "1 Monat";
        }
        this.$store.commit("setInterval", this.intervall);
        this.$store.dispatch("addInspectionToRope", {
          // intervall ... to rope?
            rope_id: this.$store.state.inspectingRopeID,
            date: new Date()
            .toJSON()
            .slice(0, 10)
            .replace(/-/g, "/"),
            assessText1: this.items[0].name,
            assessText2: this.items[1].name,
            assessText3: this.items[2].name,
            assessText4: this.items[3].name,
            assessText5: this.items[4].name,
            assessText6: this.items[5].name,
            assessText7: this.items[6].name,
            assessText8: this.items[7].name,
            assessHeader1: this.headerI1,
            assessHeader2: this.headerI2,
            assessHeader3: this.headerI3,
            assessHeader4: this.headerI4,
            assessHeader5: this.headerI5,
            assessHeader6: this.headerI6,
            assessHeader7: this.headerI7,
            assessHeader8: this.headerI8,
            assess1: this.items[0].assess,
            assess2: this.items[1].assess,
            assess3: this.items[2].assess,
            assess4: this.items[3].assess,
            assess5: this.items[4].assess,
            assess6: this.items[5].assess,
            assess7: this.items[6].assess,
            assess8: this.items[7].assess
        });
        let id =  this.$store.state.inspectingRopeID
        let facility_id =  this.$store.state.inspectingFacilityID
        let rope =  this.$store.state.inspectingRopeType
        let ropen = this.$store.state.facilityList.find(x => x.id == facility_id).ropeList.find(x => x.id == this.$store.state.inspectingRopeID).ropen
        this.$store.dispatch("updateRope", {
            id: id,
            facility_id: facility_id,
            rope: rope,
            ropen: ropen,
            interval: this.intervall
        });
        this.$store.commit("addInspection", [
          this.intervall,
          new Date()
            .toJSON()
            .slice(0, 10)
            .replace(/-/g, "/"),
          this.items[0].name,
          this.items[1].name,
          this.items[2].name,
          this.items[3].name,
          this.items[4].name,
          this.items[5].name,
          this.items[6].name,
          this.items[7].name,
          this.items[0].assess,
          this.items[1].assess,
          this.items[2].assess,
          this.items[3].assess,
          this.items[4].assess,
          this.items[5].assess,
          this.items[6].assess,
          this.items[7].assess
        ]);
        this.alreadySaved = true;
      }
    }
  }
};
</script>

<style>
.InspectionRes {
  margin: 0% auto 0% auto;
  text-align: center;
  opacity: 0.9;
  filter: alpha(opacity=90);
}

#ResultHead {
  margin-top: 5%;
  border: 1px solid black;
  border-radius: 5px;
  background-color: white;
  font-size: 200%;
  font-weight: normal;
}

.ResultTable {
  border: 1px solid black;
}

.IntervallHead {
  border: 1px solid black;
  border-radius: 5px;
  background-color: #2196f3;
  font-weight: 2%;
}

.Result {
  width: 70%;
  margin-left: auto;
  margin-right: auto;
}

table.v-table thead th {
  font-size: 120%;
}

.colorLine {
  background-color: rgb(245, 255, 100);
}

.buttons {
  background-color: white;
}
</style>
